import { CheckboxStatus } from './checkbox_status'

export const Status = ({ params, onChange, useColumnLayout = false, useShortLabel = false }) => (
  <CheckboxStatus
    params={params}
    onChange={onChange}
    useColumnLayout={useColumnLayout}
    useShortLabel={useShortLabel}
  />
)
